import calendarStore from './calendar'
import postsStore from './posts'
import classMatesStore from './classMates'
import surveyStore from './survey'
import classStore from './class';

export default {
  namespaced:true,
  modules:{
    calendar: calendarStore,
    class: classStore,
    posts: postsStore,
    classMates: classMatesStore,
    survey: surveyStore
  }
}
